import DefaultLayout from './components/Layout/Default'
import CalculatorLayout from './components/Layout/Calculator'
import Home from './components/Pages/Home'
import About from './components/Pages/About'
import Contact from './components/Pages/Contact'
import Contenimento from './components/Pages/Strutture/Contenimento'
import CampoCalcetto from './components/Pages/Strutture/CampoCalcetto'
import CampoBasket from './components/Pages/Strutture/CampoBasket'
import CampoBeach from './components/Pages/Strutture/CampoBeach'
import Altre from './components/Pages/Strutture/Altre'
import Extra from './components/Pages/Strutture/Extra'
import Step0 from './components/Pages/Calculator/Step0'
import Step1 from './components/Pages/Calculator/Step1'
import Step2 from './components/Pages/Calculator/Step2'
import Step3 from './components/Pages/Calculator/Step3'
import Step4 from './components/Pages/Calculator/Step4'
import Step5 from './components/Pages/Calculator/Step5'
import Step6 from './components/Pages/Calculator/Step6'
import Step7 from './components/Pages/Calculator/Step7'
import Finish from './components/Pages/Calculator/Finish'
import ComeFunziona from './components/Pages/ComeFunziona'
import Condizioni from './components/Pages/Condizioni'
import DoveNoleggiamo from './components/Pages/Dove'
import Faq from './components/Pages/Faq'
import NotFound from './components/Pages/404'

export const routes = [
  // {
  //   path: '/',
  //   title: 'Home',
  //   exact: true,
  //   component: Home,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/chi-siamo',
  //   title: 'About',
  //   exact: true,
  //   component: About,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/contattaci',
  //   title: 'Contattaci',
  //   exact: true,
  //   component: Contact,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/contenimento',
  //   title: 'Contenimento',
  //   exact: true,
  //   component: Contenimento,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/campi/calcetto',
  //   title: 'Calcetto',
  //   exact: true,
  //   component: CampoCalcetto,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/campi/basket',
  //   title: 'Basket',
  //   exact: true,
  //   component: CampoBasket,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/campi/beachvolley',
  //   title: 'Beach',
  //   exact: true,
  //   component: CampoBeach,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/altro',
  //   title: 'Altre',
  //   exact: true,
  //   component: Altre,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/strutture/extra',
  //   title: 'Extra',
  //   exact: true,
  //   component: Extra,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/come-funziona',
  //   title: 'Come Funziona',
  //   exact: true,
  //   component: ComeFunziona,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/condizioni',
  //   title: 'Condizioni',
  //   exact: true,
  //   component: Condizioni,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/dove-noleggiamo',
  //   title: 'Dove Noleggiamo',
  //   exact: true,
  //   component: DoveNoleggiamo,
  //   layout: DefaultLayout
  // },
  // {
  //   path: '/faq',
  //   title: 'FAQ',
  //   exact: true,
  //   component: Faq,
  //   layout: DefaultLayout
  // },
  {
    path: '/noleggia',
    title: 'Calculator - Step 0',
    exact: true,
    component: Step0,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/1',
    title: 'Calculator - Step 1',
    exact: true,
    component: Step1,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/2',
    title: 'Calculator - Step 2',
    exact: true,
    component: Step2,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/3',
    title: 'Calculator - Step 3',
    exact: true,
    component: Step3,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/4',
    title: 'Calculator - Step 4',
    exact: true,
    component: Step4,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/5',
    title: 'Calculator - Step 5',
    exact: true,
    component: Step5,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/6',
    title: 'Calculator - Step 6',
    exact: true,
    component: Step6,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/7',
    title: 'Calculator - Step 7',
    exact: true,
    component: Step7,
    layout: CalculatorLayout
  },
  {
    path: '/noleggia/:sport/grazie',
    title: 'Calculator - Finish',
    exact: true,
    component: Finish,
    layout: CalculatorLayout
  },
  {
    path: '',
    title: '404 Not Found',
    exact: false,
    component: NotFound,
    layout: DefaultLayout
  }
  // {
  //   path: '/noleggia/:sport'
  // }
]



// WEBPACK FOOTER //
// ./src/routes.js